// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget .browser {
  overflow-y: hidden;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.browser .controls {
  flex-grow: 0;
  background: #444;
  border-radius: 3px;
}

.browser .item-list {
  overflow-y: hidden;
  flex-grow: 1;
  color: white;
}

.browser .item-row .item-name {
  color: white;
}

.browser span.fancytree-title {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/browser/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".widget .browser {\n  overflow-y: hidden;\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.browser .controls {\n  flex-grow: 0;\n  background: #444;\n  border-radius: 3px;\n}\n\n.browser .item-list {\n  overflow-y: hidden;\n  flex-grow: 1;\n  color: white;\n}\n\n.browser .item-row .item-name {\n  color: white;\n}\n\n.browser span.fancytree-title {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
